<ng-container *ngIf="user">
  <p-avatar
    *ngIf="user?.profile?.file?.path || user?.['file']?.path; else defaultImage"
    [image]="user?.profile?.file?.path ? ('file/' + user?.profile?.file?.path | apiUrl) : ('file/' + user?.['file']?.path | apiUrl)"
    [shape]="shape"
    [size]="size">
  </p-avatar>

  <ng-template #defaultImage>
    <p-avatar
      [size]="size"
      [shape]="shape"
      [label]="userLabel"
      [style]="{ backgroundColor: backgroundColor, color: colorService.setColorText(backgroundColor) }">
    </p-avatar>
  </ng-template>
</ng-container>
